import axiosInstance from './axiosInstance'

export const getEmcVendorById = (vendorId) => {
  return axiosInstance.get(`/emc-vendors/${vendorId}`)
}

export const getEmcVendors = (page = 1, limit = 50, search = '', orderByKey = 'name', direction = 'asc') => {
  return axiosInstance.get(`/emc-vendors?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const exportEmcVendors = ({ search = '', orderByKey = 'name', direction = 'asc' } = {}) => {
  return axiosInstance.get(`/emc-vendors/export?search=${search}&orderByKey=${orderByKey}&direction=${direction}`, { responseType: 'blob' })
}

export const createEmcVendor = (data) => {
  return axiosInstance.post('/emc-vendors', data)
}

export const updateEmcVendor = (vendorId, data) => {
  return axiosInstance.put(`/emc-vendors/${vendorId}`, data)
}

export const deleteEmcVendor = (vendorId) => {
  return axiosInstance.delete(`/emc-vendors/${vendorId}`)
}

export const getEmcVendorNoteById = (vendorId, noteId) => {
  return axiosInstance.get(`/emc-vendors/${vendorId}/notes/${noteId}`)
}

export const getEmcVendorNotes = (vendorId, page = 1, limit = 50, search = '', orderByKey = 'createdAt', direction = 'desc') => {
  return axiosInstance.get(`/emc-vendors/${vendorId}/notes?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createEmcVendorNote = (vendorId, data) => {
  return axiosInstance.post(`/emc-vendors/${vendorId}/notes`, data)
}

export const updateEmcVendorNote = (vendorId, noteId, data) => {
  return axiosInstance.put(`/emc-vendors/${vendorId}/notes/${noteId}`, data)
}

export const deleteEmcVendorNote = (vendorId, noteId) => {
  return axiosInstance.delete(`/emc-vendors/${vendorId}/notes/${noteId}`)
}
